function scrollIntoView ({ id, scrollIntoViewOptions }) {
  window.requestAnimationFrame(() => {
    const element = document.getElementById(id)
    if (!element) return
    element.scrollIntoView(scrollIntoViewOptions)
  })
}

export { scrollIntoView }
